import type { Volume } from '../types/content';

export const volumes: Volume[] = [
  {
    number: '01',
    area: 'Workflow',
    title: 'Diesel Diagnostic Foundations & Troubleshooting Workflow',
    description:
      'Organizes the investigation from the initial symptom through testing and verification, so each check follows from the evidence already gathered.',
    topics: ['Preliminary inspections', 'DTC analysis', 'Live data', 'Testing sequences', 'Decision points'],
  },
  {
    number: '02',
    area: 'Fuel',
    title: 'Fuel System & Common Rail Diagnostics',
    description:
      'Diagnostic paths for fuel-related complaints, including hard starting, rough running, and loss of power, from the tank to the injectors.',
    topics: ['Fuel supply', 'Low-pressure delivery', 'Rail pressure', 'Air ingress', 'Pumps', 'Injector-related concerns'],
  },
  {
    number: '03',
    area: 'Air & Boost',
    title: 'Air Intake, Turbo & Boost Diagnostics',
    description: 'Structured checks for airflow and boost complaints, from intake restrictions and leaks to sensor plausibility and turbo control.',
    topics: ['Intake restrictions', 'Boost leaks', 'Boost pressure', 'MAP & MAF sensors', 'Actuators', 'Turbo control'],
  },
  {
    number: '04',
    area: 'Electrical',
    title: 'Electrical, Sensor & Actuator Diagnostics',
    description: 'Turns electrical symptoms, sensor data, and actuator codes into organized circuit checks and clear diagnostic decisions.',
    topics: ['Power supplies', 'Grounds', 'Circuit testing', 'Voltage-drop checks', 'Signal analysis', 'Actuator verification'],
  },
  {
    number: '05',
    area: 'Emissions',
    title: 'EGR, DPF, SCR & Emissions Diagnostics',
    description: 'Diagnostic paths for modern aftertreatment concerns, connecting sensor readings and system behavior to the next relevant check.',
    topics: ['EGR', 'DPF', 'Regeneration', 'Pressure & temperature sensors', 'SCR', 'AdBlue / DEF'],
  },
  {
    number: '06',
    area: 'Advanced Cases',
    title: 'Advanced Diesel Fault Diagnosis & Real-World Cases',
    description:
      'Investigations organized by symptom, evidence, tests, decisions, identified cause, and final verification — including intermittent faults and problems that appear after service or repairs.',
    topics: ['Symptom & evidence', 'Tests & decisions', 'Identified cause', 'Final verification', 'Intermittent faults', 'Post-service problems'],
  },
];
